import { Type } from 'class-transformer'
import 'reflect-metadata'

export class Specializzazione {
  deleted!: boolean;
  id!: number;
  nomespecializzazione!: string;
  @Type(() => SpecializzazioneVoce)
  specII!: SpecializzazioneVoce[];
}

export class SpecializzazioneVoce {
  id!: number;
  idSpecializzazione!: number;
  nome!: string;
  @Type(() => SpecializzazioneAttivita)
  specIII!: SpecializzazioneAttivita[];
}

export class SpecializzazioneAttivita {
  id!: number;
  idSpecializzazioneII!: number;
  nome!: string;
}
